import React, { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { SOSurveysVM } from './SOSurveysVM';
import { SOCrossslope } from '../SOCrossslope';
import { SOSpreadsheet } from '../SOSpreadsheet';
import { Alignment } from '../Alignment';
import { Notification } from 'cd-eft/components/common/Notification';
import stores from 'cd-eft/models/Stores';
import { mdiArrowCollapseVertical } from '@mdi/js';
import Icon from '@mdi/react';
import './SOSurveys.scss';
import { appConfig } from 'cd-eft/config/AppConfig';

const setStore = stores.AppStore.surveyEngineeringStore;

const SOSurveysComponent = (props) => {
  const history = useHistory();
  const vm = useRef(new SOSurveysVM(props)).current;
  useEffect(function () {
    vm.checkForProject();
  }, []);

  return (
    <div className="so-content" data-testid="so-content">
      <div className="mt-4 mx-3 display-flex flex-row justify-content-between">
        <h2 className="h3" data-testid="sotitle">
          Station/Offset
          {setStore.currentSurvey.surveyType === appConfig.hardCodes.surveyTypeCrossSlope
            ? ' Cross Slope'
            : ' Spreadsheet'}
        </h2>
        <div className="rcn-top-nav bg-white">
          <ul className="usa-button-group usa-button-group--segmented">
            <li className="usa-button-group__item">
              <button
                data-testid="surveytab"
                className={setStore.currentSubTab === 'survey' ? 'usa-button' : 'usa-button usa-button--outline'}
                onClick={setStore.currentSubTab === 'survey' ? undefined : () => (setStore.currentSubTab = 'survey')}
              >
                Survey
              </button>
            </li>
            <li className="usa-button-group__item">
              <button
                data-testid="alignmenttab"
                className={setStore.currentSubTab === 'alignment' ? 'usa-button' : 'usa-button usa-button--outline'}
                onClick={
                  setStore.currentSubTab === 'alignment' ? undefined : () => (setStore.currentSubTab = 'alignment')
                }
              >
                Alignment
              </button>
            </li>
          </ul>
        </div>
      </div>

      {setStore.currentSurvey.surveyType === appConfig.hardCodes.surveyTypeSpredsheet &&
        setStore.currentSubTab === 'survey' && <SOSpreadsheet />}
      {setStore.currentSurvey.surveyType === appConfig.hardCodes.surveyTypeCrossSlope &&
        setStore.currentSubTab === 'survey' && <SOCrossslope />}
      {setStore.currentSubTab === 'alignment' && <Alignment />}

      <Notification
        type={vm.notification.type}
        message={vm.notification.message}
        header={vm.notification.header}
        hidden={vm.notification.hidden}
        timestamp={vm.notification.timestamp}
      >
        <button
          className="usa-button usa-button--outline"
          hidden={!vm.notification.message.includes('project')}
          type="button"
          onClick={() => {
            history.push('/projects/new-project');
          }}
        >
          Go Create a Project
        </button>
      </Notification>
    </div>
  );
};
export const SOSurveys = observer(SOSurveysComponent);

export const ButtonToPlaceRow = (props) => {
  const { i, addRow } = props;
  return (
    <div className="add-row-button" data-testid={`add-row-button-${i}`} onClick={() => addRow(i)}>
      <Icon path={mdiArrowCollapseVertical} title="" size={1} />
    </div>
  );
};
